function submenu_columns(breakpoint) {
    const submenu_navs = document.querySelectorAll('.enhanced-submenu .submenu-nav');
    submenu_navs.forEach(submenu_nav => {
        // get lis
        let counter = {
            li: [],
            lvl: 1,
            max_lvl: 3,
        }
        const submenu_nav_ul = submenu_nav.querySelector('.submenu-nav-ul');
        if (submenu_nav_ul !== null) {
            lis = Array.from(submenu_nav_ul.children);
            lis.forEach(li => {
                counter.lvl = 1;
                submenu_lis(li, counter);
            });
        } else {
            counter.li = submenu_nav.querySelectorAll('li');
        }
        // create container
        const container = document.createElement('div');
        container.classList = 'submenu-nav-flex flex justify-between w-full -mx-4';
        // create div
        let div = document.createElement('div');
        let div_class = 'px-4';
        // get columns
        const target_columns = Number(submenu_nav.dataset.columns);
        let columns = 1;
        switch (breakpoint) {
            case 'lg':
                columns = (target_columns >= 2) ? 2 : columns;
                break;
            case 'xl':
                columns = (target_columns >= 2) ? 2 : columns;
                columns = (target_columns >= 3) ? 3 : columns;
                break;
            case '2xl':
                columns = (target_columns >= 2) ? 2 : columns;
                columns = (target_columns >= 3) ? 3 : columns;
                columns = (target_columns >= 4) ? 4 : columns;
                break;
        }
        div_class += (columns > 1) ? ' w-1/'+ columns : ' w-full';
        div.classList = div_class;
        // create ul
        let ul = document.createElement('ul');
        // append elements
        let cur_col = 1;
        let cur_item = 1;
        let items_per_col = Math.ceil(counter.li.length / columns);
        for (let i = 0; i < counter.li.length; i++) {
            let li = counter.li[i];
            let avoid = li.classList.contains('avoid-' + columns);
            let force = li.classList.contains('force-' + columns);
            if ((cur_item > items_per_col || force) && (cur_col < columns) && !avoid) { // new column
                div.appendChild(ul);
                container.appendChild(div);
                div = document.createElement('div');
                div.classList = div_class;
                ul = document.createElement('ul');
                cur_item = 1;
                cur_col++;
            }
            ul.appendChild(li);
            cur_item++;
        }
        div.appendChild(ul);
        container.appendChild(div);
        // append container
        submenu_nav.innerHTML = '';
        submenu_nav.appendChild(container);
    });
}

function submenu_lis(li, counter) {
    if (!li.classList.contains('!hidden')) {
        let el = document.createElement('li');
        el.classList = li.classList;
        el.classList.add('lvl-' + counter.lvl);
        el.appendChild(li.querySelector('a'));
        counter.li.push(el);
        if (li.classList.contains('menu-item-has-children')) {
            const ul = li.querySelector('ul');
            if (ul !== null && !ul.classList.contains('!hidden')) {
                counter.lvl++;
                if (counter.lvl <= counter.max_lvl) {
                    const child_lis = Array.from(ul.children);
                    child_lis.forEach(li => {
                        submenu_lis(li, counter);
                    });
                    counter.lvl--;
                }
            }
        }
    }
}

window.addEventListener('breakpoint', (e) => submenu_columns(e.detail.breakpoint));